import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: '[title-template]' })
export class TitleTemplateDirective {
    constructor(public template: TemplateRef<any>) { }
}
